/**
 * Eagerly preload route chunks to avoid Suspense fallbacks on navigation.
 * Uses requestIdleCallback to ensure we don't block the critical initial render.
 */
import { logger } from '@ui/utils/logger';
import { AppMode } from '@ui/constants';

export const preloadRoutes = (mode: AppMode) => {
    const load = () => {
        try {
            const preloaders: Record<AppMode, () => void> = {
                [AppMode.PATIENT_REGISTRY]: () => {
                    void import('../pages/PatientRegistry/Projects');
                    void import('../pages/PatientRegistry/Integrations');
                    void import('../pages/PatientRegistry/CaseFinding');
                },
                [AppMode.PATIENT_JOURNEY]: () => {
                    void import('../pages/Dashboard');
                    void import('../pages/Patients');
                    void import('../pages/Cohorts');
                    void import('../pages/Calculations');
                    void import('../pages/DeIdentification');
                    void import('../pages/SourceRegistry');
                    void import('../pages/DataIngestion');
                    void import('../pages/DbExplorer');
                    void import('../pages/DbChat');
                    void import('../pages/Chat');
                    void import('../pages/DataCuration');
                    void import('../pages/Audit');
                    void import('../pages/Administration');
                    void import('../pages/Feedback');
                    void import('../pages/License');
                },
            };

            preloaders[mode]();
        } catch (error) {
            logger.warn('Failed to preload routes', error);
        }
    };

    // Wait for the browser to be idle before starting the heavy network requests
    if ('requestIdleCallback' in window) {
        window.requestIdleCallback(load, { timeout: 5000 });
    } else {
        // Fallback for browsers that don't support requestIdleCallback
        setTimeout(load, 2000);
    }
};
